import { render, staticRenderFns } from "./FileBubble.vue?vue&type=template&id=3fc1205c&scoped=true&"
import script from "./FileBubble.vue?vue&type=script&lang=js&"
export * from "./FileBubble.vue?vue&type=script&lang=js&"
import style0 from "./FileBubble.vue?vue&type=style&index=0&id=3fc1205c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1205c",
  null
  
)

export default component.exports